import styled from '@emotion/styled';
import { defaultButtonsGap } from 'styles/globalStyles';

export const StyledButtonsBlock = styled.div`
  display: flex;
  gap: ${defaultButtonsGap};
  align-items: center;
`;
